import Header from "@/components/ui/Header";
import { useNavigate } from "react-router-dom";

const Contact = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background text-foreground">

      <Header />

      {/* Content */}
      <div className="max-w-2xl mx-auto p-6">

        <h1 className="text-3xl font-bold mb-6">Contact Us</h1>

        <p className="mb-4">
          Have a suggestion, correction, or feedback?
        </p>

        <p className="mb-4">
          We'd love to hear from you.
        </p>

        <p className="mb-4">
          If you notice incorrect information about a ship or want to suggest a
          feature for MarineKnow, please reach out.
        </p>

        <p className="font-semibold text-lg mt-6">
          marineknow2026@gmail.com
        </p>

        <p className="text-sm text-muted-foreground mt-2">
          We usually respond within 48 hours.
        </p>

        {/* Back Button */}
        <button
          onClick={() => navigate("/")}
          className="mt-8 text-primary underline hover:opacity-80"
        >
          Back to Home
        </button>

      </div>
    </div>
  );
};

export default Contact;
